import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "auth-loading"
};
const _hoisted_2 = {
  class: "auth-blocked-content"
};
const _hoisted_3 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_router_view = _resolveComponent("router-view");
  return $data.authState === null ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_loading, {
    size: "36px",
    vertical: ""
  }, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("加载中...", -1)]))]),
    _: 1
  })])) : $data.authState === false ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "auth-blocked",
    style: _normalizeStyle($options.blockPageStyle)
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h1", null, _toDisplayString($data.blockPage.title || '服务未授权'), 1), _createElementVNode("div", {
    class: "auth-blocked-html",
    innerHTML: $data.blockPage.html
  }, null, 8, _hoisted_3)])], 4)) : (_openBlock(), _createBlock(_component_router_view, {
    key: 2
  }));
}